import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { APIInformationPage } from 'src/app/model/page/api-information-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ConfigService } from 'src/app/service/config.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-api-information-page',
  templateUrl: './api-information-page.component.html',
  styleUrls: ['./api-information-page.component.scss']
})
export class APIInformationPageComponent implements OnInit {
  pageName = 'API INFORMATION';
  apiInformation: APIInformationPage = {} as APIInformationPage;
  apiInfodata: any = [];

  constructor(private contentfulService: ContentfulService, private configService: ConfigService) {}

  async ngOnInit(): Promise<void> {
    htmlTitle.filter((title) => {
      if (title.page === 'api-info') {
        this.apiInformation.htmlTitle = title.htmlTitle;
      }
    });
    localStorage.removeItem('ndcportal_redirect');
    this.apiInformation.apiInformationCards = [];
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((apiinformation) => {
      this.mapHtmlTitle(apiinformation.items);
      apiinformation.includes.Entry.filter((entry: Entry<any>) => ModelValidator.isBanner(entry)).forEach((entry: Entry<any>) => {
        this.mapEntryToBanner(entry);
      });
      apiinformation.includes.Entry.filter((entry: Entry<any>) => ModelValidator.isCard(entry))
        .filter((entry: Entry<any>) => entry.fields)
        .forEach(async (entry: Entry<any>) => {
          await this.mapEntryToUseAPIInormationCards(entry);
        });
      this.apiInformation.apiInformationCards.sort((a, b) => a.order - b.order);
    });
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.apiInformation.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    this.apiInformation.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: ''
    };

  }

  private async mapEntryToUseAPIInormationCards(entry: Entry<any>) {
    let headerImage: any = entry.fields['headImage'];
    this.addEntryToMap(entry, headerImage);
  }

  private addEntryToMap(entry: Entry<any>, headerImage: any) {
    this.apiInformation.apiInformationCards.push({
      title: entry.fields['title'] as string,
      headImage: headerImage.fields?.file?.url,
      order: entry.fields['order'] as number,
      titleLink: '',
      richTextBody: entry.fields['body'] as string
    });
  }

}
